// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingNavbar-cls1_HMt","cls2":"CoScientistLandingNavbar-cls2_tc5 CoScientistLandingNavbar-cls1_HMt"};